import { HistoryEvent } from "./tactics.model";
export class CountUpPlayer {
    constructor(name, numberOfRounds) {
        this.totalScore = 0;
        this.rounds = [];
        this.name = name;
        this.rounds = [];
        for (let i = 1; i <= numberOfRounds; i++) {
            this.rounds.push(new CountUpRound(i, null));
        }
    }
}
export class CountUpRound {
    constructor(round, score) {
        this.round = round;
        this.score = score;
    }
}
export class CountUpHistoryEvent extends HistoryEvent {
    constructor(type, playerIndex, segment, pointsAdded, previousTotal) {
        super(type, playerIndex, segment);
        this.pointsAdded = pointsAdded;
        this.previousTotal = previousTotal;
    }
}
